import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import camelcaseKeys from "camelcase-keys";
import {UserInvite} from "../../shared/models/user-invite.model";

@Injectable({
  providedIn: 'root'
})
export class UserInviteService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  get(): Observable<any> {
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `userInvite/getList`);
  }

  invite(userInvite: UserInvite){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `userInvite/invite-user-by-email/`,
      camelcaseKeys(userInvite as any , {deep:true, pascalCase: true})
    )
  }

  cancel(userInviteId: number){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `userInvite/cancel/${userInviteId}`, {})
  }
}
